var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66675 1.66699C5.11446 1.66699 4.66675 2.11471 4.66675 2.66699V3.66699H3.66675C2.56218 3.66699 1.66675 4.56242 1.66675 5.66699V15.667C1.66675 16.7716 2.56218 17.667 3.66675 17.667H15.6667C16.7713 17.667 17.6667 16.7716 17.6667 15.667V5.66699C17.6667 4.56242 16.7713 3.66699 15.6667 3.66699H14.6667V2.66699C14.6667 2.11471 14.219 1.66699 13.6667 1.66699C13.1145 1.66699 12.6667 2.11471 12.6667 2.66699V3.66699H6.66675V2.66699C6.66675 2.11471 6.21903 1.66699 5.66675 1.66699ZM5.66675 6.66699C5.11446 6.66699 4.66675 7.11471 4.66675 7.66699C4.66675 8.21928 5.11446 8.66699 5.66675 8.66699H13.6667C14.219 8.66699 14.6667 8.21928 14.6667 7.66699C14.6667 7.11471 14.219 6.66699 13.6667 6.66699H5.66675Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackCalendar);
export default __webpack_public_path__ + "static/media/black-calendar.dfc668d009e00a6e537a6fb1288cb01a.svg";
export { ForwardRef as ReactComponent };